import { useWaitlist } from "@/context/WaitlistContext";
import { AppDownloadButton } from "./AppDownloadButton";
import { CtaButton } from "./CTA";
import { MaskLines, Reveal } from "./Motion";

const LINES = ["Build with better tools.", "Find better opportunities.", "Understand your audience.", "Take control of your next move."];

export const FinalCTA = () => {
  const { openWaitlist } = useWaitlist();
  return (
    <section data-testid="final-cta-section" className="relative overflow-hidden bg-pa-orange text-pa-black">
      <div className="mx-auto max-w-[1400px] px-5 py-section-sm sm:px-8 lg:px-12 lg:py-section">
        <MaskLines
          lines={["Ready to build", "beyond the", "stream?"]}
          label="Ready to build beyond the stream?"
          className="font-display text-[clamp(3.6rem,12vw,12rem)] uppercase leading-[0.84]"
        />
        <div className="mt-14 grid gap-10 lg:grid-cols-12">
          <Reveal className="lg:col-span-6">
            <p className="text-lg font-medium md:text-xl">Your music career deserves more than another upload button.</p>
            <ul className="mt-6 space-y-1 font-display text-2xl uppercase md:text-3xl">
              {LINES.map((l) => <li key={l}>{l}</li>)}
            </ul>
          </Reveal>
          <Reveal delay={0.15} className="flex flex-col gap-4 self-end sm:flex-row lg:col-span-6 lg:justify-end">
            <AppDownloadButton variant="dark" label="Download the Pitchally app" source="final-cta" testId="final-download-btn" />
            <CtaButton variant="outline-dark" icon={false} data-testid="final-waitlist-btn" onClick={() => openWaitlist({ source: "final-waitlist" })}>
              Join the waitlist
            </CtaButton>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
